/**
 * PROPRIETARY AND CONFIDENTIAL
 * Copyright © 2026 Contractor Co-Pilot. All Rights Reserved.
 */

const STYLE_TAG_ID = "theme-overrides";

function getStyleTag(): HTMLStyleElement {
  let tag = document.getElementById(STYLE_TAG_ID) as HTMLStyleElement | null;
  if (!tag) {
    tag = document.createElement("style");
    tag.id = STYLE_TAG_ID;
    document.head.appendChild(tag);
  }
  return tag;
}

export function applyThemeVars(vars: Record<string, string>): void {
  const lines = Object.entries(vars).map(([k, v]) => `  ${k}: ${v};`);
  getStyleTag().textContent = `:root {\n${lines.join("\n")}\n}`;
}

export function hasThemeStyleTag(): boolean {
  if (typeof window === "undefined") return false;
  const tag = document.getElementById(STYLE_TAG_ID);
  return Boolean(tag?.textContent?.trim());
}

export function removeThemeStyleTag(): void {
  if (typeof window === "undefined") return;
  document.getElementById(STYLE_TAG_ID)?.remove();
}
